import { gql, useQuery } from '@apollo/client';

type Vars = {
  organizationId: string;
  offset: number;
  limit: number;
  filter?: { name: string };
};

type CurrentUser = {
  id: string;
  name: string;
  organization: {
    users: { id: string; name: string; email?: string; avatarUrl?: string }[];
    usersCount: number;
  };
};

type Data = {
  currentUser: CurrentUser;
};

const GET_ORGANIZATION_USERS = gql`
  query getOrganizationUsers(
    $organizationId: ID!
    $offset: Int!
    $limit: Int!
    $filter: UserFilter
  ) {
    currentUser {
      __typename
      id
      name
      organization(organizationId: $organizationId) {
        usersCount
        users(offset: $offset, limit: $limit, filter: $filter) {
          id
          name
          email
          avatarUrl
        }
      }
    }
  }
`;

export const useGetOrganizationUsers = ({
  organizationId,
  offset,
  limit,
  filter
}: {
  organizationId: string;
  offset: number;
  limit: number;
  filter?: {
    name: string;
  };
}) =>
  useQuery<Data, Vars>(GET_ORGANIZATION_USERS, {
    variables: {
      organizationId,
      offset,
      limit,
      filter
    }
  });
